'use client';

import { useState } from 'react';

import { cn } from '@/lib/utils';

import { MemoizedMarkdown } from '../memoized-markdown';

export interface TruncatedMarkdownProps {
  id: string;
  content: string;
  maxLines?: number;
  className?: string;
}

const DEFAULT_MAX_LINES = 4;

function truncateToLines(source: string, maxLines: number): string {
  return `${source.split('\n').slice(0, maxLines).join('\n').replace(/\s+$/u, '')}\u2026`;
}

export function TruncatedMarkdown({
  id,
  content,
  maxLines = DEFAULT_MAX_LINES,
  className,
}: TruncatedMarkdownProps) {
  const [expanded, setExpanded] = useState(false);

  const trimmed = content.trim();
  if (trimmed.length === 0) return null;

  const lineCount = trimmed.split('\n').length;
  const isTruncatable = lineCount > maxLines;
  const visible = !isTruncatable || expanded ? trimmed : truncateToLines(trimmed, maxLines);

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="text-sm leading-snug text-foreground">
        <MemoizedMarkdown id={id} content={visible} />
      </div>
      {isTruncatable && (
        <button
          type="button"
          className="self-start text-sm font-medium text-primary hover:text-primary/80"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
}
